var BackgroundVariant;
(function (BackgroundVariant) {
    BackgroundVariant["GRAY"] = "gray";
    BackgroundVariant["WHITE"] = "white";
    BackgroundVariant["BURGUNDY"] = "burgundy";
    BackgroundVariant["PURPLE"] = "purple";
})(BackgroundVariant || (BackgroundVariant = {}));

export { BackgroundVariant };
